export default {

    state: {
      cnj: null
    },
  
    mutations: {
        setCnj(state, payload) {
          state.cnj = payload;
        }
    },
  
    getters: {
      getCnj(state) {
          return state.cnj;
      }
    },

    actions: {
        setCnj({commit}, cnj){
          commit('setCnj', cnj);
        }
    },
    
  }